import React, { useState, useEffect } from 'react';
import { Layout, Typography, Space, Button, Badge, Dropdown } from 'antd';
import { BellOutlined, UserOutlined, LogoutOutlined, DownOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { formatTokenTimeLeft } from '../utils/tokenUtils';
import ThemeToggle from './ThemeToggle';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const Header: React.FC = () => {
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();
  const [tokenTimeLeft, setTokenTimeLeft] = useState<string>('');

  useEffect(() => {
    if (token) {
      const updateTokenTime = () => {
        setTokenTimeLeft(formatTokenTimeLeft(token));
      };
      
      updateTokenTime();
      const interval = setInterval(updateTokenTime, 1000);
      
      return () => clearInterval(interval);
    }
  }, [token]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'My Profile',
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  return (
    <AntHeader
      style={{
        background: 'var(--header-bg)',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid var(--header-border)',
      }}
    >
      <Title level={3} style={{ margin: 0, color: 'var(--text-primary)' }}>
      </Title>
      
      <Space size="middle">
        <ThemeToggle />
        
        <Badge count={0} size="small">
          <Button type="text" icon={<BellOutlined />} size="large" />
        </Badge>
        
        {tokenTimeLeft && (
          <Button type="text" icon={<ClockCircleOutlined />} size="large">
            {tokenTimeLeft}
          </Button>
        )}
        
        <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
          <Button type="text" size="large">
            <Space>
              <UserOutlined />
              {user?.name || 'Admin Panel'}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
